export default ({
  ROUTE_CHANGE            : 'ROUTE_CHANGE',

  CONFIG_MENU_SET_UPDATE  : 'CONFIG_MENU_SET_UPDATE',
  CONFIG_MENU_TOGGLE_DONE : 'CONFIG_MENU_TOGGLE_DONE'
});